"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Chart_1 = require("../LineChart/Chart");
var Axis_1 = require("./Axis");
var Moment = require("moment-timezone");
var monitoring_1 = require("../../services/monitoring");
var classNames = require("classnames");
var d3Axis = require("d3-axis");
var d3Path = require("d3-path");
var d3Format = require("d3-format");
var d3Scale = require("d3-scale");
var d3Array = require("d3-array");
var d3Shape = require("d3-shape");
var d3 = __assign({}, d3Axis, d3Path, d3Format, d3Scale, d3Array, d3Shape);
var cumulativeKey = 'cumulativeAggregation';
var LineChart = /** @class */ (function (_super) {
    __extends(LineChart, _super);
    function LineChart(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDocumentClick = function (event) {
            var node = _this.state.root;
            // ensure there's an active index that might need reset
            if (_this.state.activeDataIndex > -1 && _this.state.activeSeriesIndex > -1) {
                // if event, and node doesn't contain the srcElement, and the srcElement isn't the focus datapoint, deselect
                if (event &&
                    !node.contains(event.srcElement) &&
                    !event.srcElement.classList.contains('data-point-active-outside')) {
                    // deselect active indexes
                    _this.setState({ activeDataIndex: -1, activeSeriesIndex: -1 });
                }
            }
        };
        _this.calculateTooltipContainerState = function (dataIndex) {
            var _a = _this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey;
            var _b = _this.state, xScale = _b.xScale, yScale = _b.yScale, data = _b.data;
            var _c = _this.state, activeSeriesIndex = _c.activeSeriesIndex, activeDataIndex = _c.activeDataIndex, hoveredSeriesIndex = _c.hoveredSeriesIndex, hoveredDataIndex = _c.hoveredDataIndex, size = _c.size, showGlobalTotal = _c.showGlobalTotal;
            // Calculating the {x,y} position for the current dataIndex in order to show the toolTip
            if (dataIndex > -1 && data.length > 0) {
                var dataItem = data[0][dataIndex];
                var cx = xScale(dataItem[xAxisKey]);
                var cy = yScale(dataItem[yAxisKey]);
                // Conditionally move the tooltip away from the chart edges
                var _d = _this.props, width = _d.width, height = _d.height, padding = _d.padding;
                var _e = _this.state, toolTipWidth = _e.toolTipWidth, toolTipHeight = _e.toolTipHeight;
                // Create the tooltip container that's full height to contain all of the tooltips
                var yThreshold = 0;
                // Calculate the right side overflow threshold
                var xThreshold = showGlobalTotal ? 165 : 65;
                var flipped = false;
                if (cx > width - padding * 2 - xThreshold) {
                    flipped = true;
                }
                else {
                    flipped = false;
                }
                return {
                    x: cx,
                    y: cy,
                    flipped: flipped
                };
            }
            else {
                return { x: null, y: null };
            }
        };
        _this.toolTipRef = function (element) {
            var newState = __assign({}, _this.state);
            if (element) {
                var changes = false;
                if (_this.state.toolTipHeight === undefined ||
                    _this.state.toolTipHeight < element.offsetHeight) {
                    newState.toolTipHeight = element.offsetHeight;
                    changes = true;
                }
                if (_this.state.toolTipWidth === undefined ||
                    _this.state.toolTipWidth < element.offsetWidth) {
                    newState.toolTipWidth = element.offsetWidth;
                    changes = true;
                }
                if (changes) {
                    _this.setState(newState);
                }
            }
        };
        _this.generateD3State = function (props) {
            var data = _this.synchronizeData(props);
            var xAxisKey = props.xAxisKey, yAxisKey = props.yAxisKey;
            var size = {
                width: props.width,
                height: props.height,
                padding: props.padding
            };
            var scaleData;
            switch (props.chartType) {
                case 0:
                    // Concat all arrays to find the max individual value
                    scaleData = data.reduce(function (array, next) {
                        return array.concat(next);
                    }, []);
                    break;
                case 1:
                    // Sum all yAxisKey values at each data index
                    var dataKeys_1 = Object.keys(data);
                    if (dataKeys_1.length) {
                        var summedStartingArray = JSON.parse(JSON.stringify(data[dataKeys_1[0]]));
                        var summedData = summedStartingArray.map(function (dataItem, index) {
                            var val = 0;
                            dataKeys_1.map(function (dataKey) {
                                val = val + data[dataKey][index][yAxisKey];
                            });
                            dataItem[yAxisKey] = val;
                            return dataItem;
                        });
                        scaleData = summedData;
                    }
                    else {
                        scaleData = [];
                    }
                    break;
                case 2:
                    break;
                default:
                    scaleData =
                        (data &&
                            data.length &&
                            data.reduce(function (array, next) {
                                if (!array) {
                                    array = [];
                                }
                                return array.concat(next);
                            })) ||
                            [];
                    break;
            }
            var xValues = scaleData.map(function (d) {
                return d[xAxisKey];
            });
            var xMax = function (dataArray) { return d3.max(dataArray, function (d) { return d[props.xAxisKey]; }); };
            var xMin = function (dataArray) { return d3.min(dataArray, function (d) { return d[props.xAxisKey]; }); };
            var yMax = function (dataArray) { return d3.max(dataArray, function (d) { return d[props.yAxisKey]; }); };
            var xScale;
            var niceNumber = 3;
            var xAxisTickValues = [];
            var xAxisGranularity = 0;
            if (_this.props.dateSeries) {
                xScale = d3
                    .scaleTime()
                    .domain([
                    new Date(xMin(scaleData) * 1000),
                    new Date(xMax(scaleData) * 1000)
                ])
                    .range([props.padding, props.width - props.padding * 2]);
                // .nice(d3.timeHour, 24)
                // nice extends a calculated domain to even formatted numbers that still encompass the domain
                var xScaleD3_1 = xScale;
                xScale = function (dateString) {
                    var date = new Date(parseInt(dateString, 10) * 1000);
                    return xScaleD3_1(date);
                };
                xScale.invert = xScaleD3_1.invert;
                xScale.domain = xScaleD3_1.domain;
                xScale.range = xScaleD3_1.range;
                xScale.rangeRound = xScaleD3_1.rangeRound;
                xScale.clamp = xScaleD3_1.clamp;
                xScale.interpolate = xScaleD3_1.interpolate;
                xScale.ticks = xScaleD3_1.ticks;
                xScale.copy = xScaleD3_1.copy;
                var minXAxisTickSpacing = 30;
                var maxLabelWidth = 50;
                var maxTicks = Math.min(innerWidth / (minXAxisTickSpacing + maxLabelWidth), 8);
                // Generate tick values using only one data-series so the tick indexes are calculated correctly.
                var tickSamplingArray = data[0] || [];
                xAxisTickValues = _this.generateXTicks(tickSamplingArray.map(function (d) {
                    return d[xAxisKey];
                }), 4, maxTicks);
                // Calculate granularity based off the number of days in data set
                var calcDaysInRange_1 = function (start, end) {
                    return Math.abs(Moment(start).diff(Moment(end), 'days')) + 1;
                };
                var determineGranularity = function (startDate, endDate) {
                    var daysInRange = calcDaysInRange_1(startDate, endDate);
                    if (daysInRange >= 365) {
                        return 30;
                    }
                    else if (daysInRange >= 30) {
                        return 7;
                    }
                    else {
                        return 1;
                    }
                };
                // Hope the first data array is sorted, pull the
                xAxisGranularity = determineGranularity(xScale.domain()[0], xScale.domain()[1]);
            }
            else {
                xScale = d3
                    .scaleLinear()
                    .domain([0, xMax(scaleData)])
                    .range([props.padding, props.width - props.padding * 2])
                    .nice(3);
            }
            // OLD yScale using the actualy yMax from the data
            // let yScale = d3
            //   .scaleLinear()
            //   .domain([0, yMax(scaleData)])
            //   .range([this.props.height - this.props.padding, this.props.padding])
            //   .nice(4)
            // NEW yScale using yMax + 5% to add space at the top of the chart
            var yScale = d3
                .scaleLinear()
                .domain([0, yMax(scaleData) * 1.2])
                .range([_this.props.height - _this.props.padding, _this.props.padding])
                .nice(4);
            var d3State = {
                yScale: yScale,
                xScale: xScale,
                size: size,
                xValues: xValues,
                xAxisTickValues: xAxisTickValues,
                xAxisGranularity: xAxisGranularity,
                data: data
            };
            var newd3State = __assign({}, d3State, _this.synchronizeDataSeries(props, d3State));
            return newd3State;
        };
        _this.synchronizeData = function (props) {
            var yAxisKey = props.yAxisKey;
            var data = [];
            var dataSeriesArray;
            if (Array.isArray(props.children)) {
                dataSeriesArray = props.children.map(function (child, index) {
                    var dataArray = child.props.data || [];
                    if (dataArray.length) {
                        data.push(dataArray);
                    }
                });
                data = data.map(function (array, index) {
                    var previousDataArray = index - 1 >= 0 ? data[index - 1] : null;
                    if (previousDataArray !== null && previousDataArray.length) {
                        return array.map(function (item, prevIndex) {
                            item[cumulativeKey] =
                                previousDataArray[prevIndex][cumulativeKey] + item[yAxisKey];
                            return item;
                        });
                    }
                    else {
                        return array.map(function (item) {
                            item[cumulativeKey] = item[yAxisKey];
                            return item;
                        });
                    }
                });
                return data;
            }
            else {
                return props.data;
            }
        };
        _this.synchronizeDataSeries = function (props, d3state) {
            var xAxisKey = props.xAxisKey, yAxisKey = props.yAxisKey, showAreas = props.showAreas, chartType = props.chartType;
            var self = _this;
            var dataSeriesArray;
            var yScale = d3state.yScale, xScale = d3state.xScale, size = d3state.size, tooltipPosition = d3state.tooltipPosition, data = d3state.data;
            if (Array.isArray(props.children)) {
                dataSeriesArray = props.children.map(function (child, seriesIndex) {
                    var previousDataArray = seriesIndex - 1 >= 0 ? data[seriesIndex - 1] : null;
                    var dataArray = data[seriesIndex] || [];
                    var color = child.props.color || '#ccc';
                    // Using old style classes for now... Apply -gray for 0, otherwise subtract 1 to start at 0...
                    var colorSuffix = seriesIndex;
                    if (colorSuffix === 0) {
                        colorSuffix = 'gray';
                    }
                    else {
                        colorSuffix = colorSuffix - 1;
                    }
                    var linePath, areaPath, pathGenerator;
                    switch (chartType) {
                        case 0:
                            pathGenerator = d3
                                .line()
                                .x(function (d) {
                                return xScale(d[xAxisKey]);
                            })
                                .y(function (d) {
                                return yScale(d[yAxisKey]);
                            })
                                .curve(d3.curveLinear);
                            linePath = pathGenerator(dataArray);
                            break;
                        case 1:
                            if (previousDataArray) {
                                pathGenerator = d3
                                    .area()
                                    .x(function (d) {
                                    return xScale(d[xAxisKey]);
                                })
                                    .y0(function (d, index) {
                                    var previousCumulativeValue = previousDataArray[index][cumulativeKey];
                                    return yScale(previousCumulativeValue);
                                })
                                    .y1(function (d, index) {
                                    return yScale(d[cumulativeKey]);
                                });
                                areaPath = pathGenerator(dataArray);
                            }
                            else {
                                pathGenerator = d3
                                    .area()
                                    .x(function (d) {
                                    return xScale(d[xAxisKey]);
                                })
                                    .y0(function (d) {
                                    return size.height - size.padding;
                                })
                                    .y1(function (d) {
                                    return yScale(d[yAxisKey]);
                                });
                                areaPath = pathGenerator(dataArray);
                            }
                            break;
                        case 2:
                            break;
                        default:
                            pathGenerator = d3
                                .line()
                                .x(function (d) {
                                return xScale(d[xAxisKey]);
                            })
                                .y(function (d) {
                                return yScale(d[yAxisKey]);
                            })
                                .curve(d3.curveLinear);
                            linePath = pathGenerator(dataArray);
                            break;
                    }
                    var key = dataArray.length + color + seriesIndex;
                    var dataSeriesProps = {
                        data: dataArray,
                        size: size,
                        xScale: xScale,
                        yScale: yScale,
                        xAxisKey: xAxisKey,
                        yAxisKey: yAxisKey,
                        area: showAreas,
                        chartType: chartType,
                        linePath: linePath,
                        areaPath: areaPath,
                        pathGenerator: pathGenerator,
                        seriesIndex: seriesIndex,
                        estimateDataPoint: self.estimateDataPoint,
                        color: color,
                        key: key
                    };
                    var syncedDataSeries = React.cloneElement(child, __assign({}, child.props, dataSeriesProps));
                    return (React.createElement("g", { className: "line-chart__data-series", key: key }, syncedDataSeries));
                });
                // The reverse here is to render in the correct order so that the areas don't overlap data points.
                return { dataSeriesElements: dataSeriesArray.reverse(), data: data };
            }
            else {
                return { dataSeriesElements: null, data: _this.props.data };
            }
        };
        _this.estimateDataPoint = function (data, index, yAxisKey, xAxisKey) {
            // Let's find the next real value
            var nextRealValueIndex = _this.findNextRealValueIndex(data, index, yAxisKey);
            var previousRealValueIndex = _this.findPreviousRealValueIndex(data, index, yAxisKey);
            // Continue estimation as long as we've found a next value
            if (nextRealValueIndex !== null) {
                // Calculate increment per point
                var incrementPerDataPoint = _this.estimateIncrementBetweenIndexes(data, previousRealValueIndex, nextRealValueIndex, yAxisKey);
                // Create a fabricated data point with the current value + the increment
                var nextFabricatedPoint = {};
                var currentFabricatedPoint = {};
                // Set the timestamp
                currentFabricatedPoint[xAxisKey] = data[index][xAxisKey];
                // Set the estimated reach value
                currentFabricatedPoint[yAxisKey] =
                    data[previousRealValueIndex][yAxisKey] +
                        incrementPerDataPoint * (index - previousRealValueIndex);
                return currentFabricatedPoint;
            }
            else {
                return null;
            }
        };
        _this.createCircleElements = function (seriesIndex, color, props, d3state) {
            var xAxisKey = props.xAxisKey, yAxisKey = props.yAxisKey, chartType = props.chartType;
            var self = _this;
            var yScale = d3state.yScale, xScale = d3state.xScale, size = d3state.size, tooltipPosition = d3state.tooltipPosition, data = d3state.data;
            var currentArray = data[seriesIndex];
            var nextDataArray = seriesIndex < data.length + 1 ? data[seriesIndex + 1] : null;
            var previousDataArray = seriesIndex - 1 >= 0 ? data[seriesIndex - 1] : null;
            var circleElements = currentArray.map(function (item, index) {
                var insideRadius = 3, outsideRadius = 4;
                var circleProps = {
                    cx: xScale(item[xAxisKey]),
                    cy: yScale(item[yAxisKey]),
                    r: insideRadius,
                    key: index,
                    'data-index': index,
                    'data-series-index': seriesIndex
                };
                if (previousDataArray && previousDataArray.length && chartType === 1) {
                    circleProps = __assign({}, circleProps, { cy: yScale(item[cumulativeKey]) });
                }
                var outsideCircleStyles = {
                    stroke: '#212934',
                    strokeWidth: '1',
                    fill: 'transparent'
                };
                var insideCircleStyles = {
                    stroke: 'white',
                    strokeWidth: '1',
                    fill: color
                };
                return (React.createElement("g", { className: "line-chart__data-points", key: circleProps.key },
                    React.createElement("circle", __assign({}, circleProps, { style: insideCircleStyles })),
                    React.createElement("circle", __assign({}, circleProps, { r: outsideRadius, key: circleProps.key + 'outside', style: outsideCircleStyles }))));
            });
            return circleElements;
        };
        _this.onChartMouseOut = function (e) {
            _this.setState({
                hoveredDataIndex: -1,
                hoveredSeriesIndex: -1
            });
        };
        _this.onChartClick = function (e) {
            _this.updateActiveDataIndexFromMouseEvent(e);
        };
        _this.onChartMouseOver = function (e) {
            _this.updateActiveDataIndexFromMouseEvent(e);
        };
        _this.updateActiveDataIndexFromMouseEvent = function (e) {
            var _a = _this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, padding = _a.padding;
            var _b = _this.state, yScale = _b.yScale, xScale = _b.xScale, xValues = _b.xValues, data = _b.data, hoveredSeriesIndex = _b.hoveredSeriesIndex;
            // Calculate position based on offset and chart padding
            var pos = [e.nativeEvent.offsetX - padding / 2, e.nativeEvent.offsetY];
            var index = _this.findDataIndexByXPos(pos[0]);
            var newHoveredSeriesIndex = hoveredSeriesIndex;
            if (index === undefined) {
                return;
            }
            // Determine the closest data series to the mouse y position
            var minDistanceToPoint = Number.MAX_VALUE;
            data.map(function (dataItem, dataIndex) {
                var yPointPosition = yScale(dataItem[index]);
                var curDistanceToPoint = Math.abs(yPointPosition - pos[1]);
                if (curDistanceToPoint < minDistanceToPoint) {
                    minDistanceToPoint = curDistanceToPoint;
                    newHoveredSeriesIndex = dataIndex;
                }
            });
            // Recalculate the tooltip container state
            var containerState = _this.calculateTooltipContainerState(index);
            // Tell the frontend there's a new data index to supply new tooltips
            var unusedReturnValue = _this.props.onActiveIndexChange
                ? _this.props.onActiveIndexChange(index)
                : null;
            // Set the new hovered state to rerender with the new hover state
            _this.setState({
                hoveredDataIndex: index,
                hoveredSeriesIndex: newHoveredSeriesIndex,
                tooltipPosition: containerState
            });
        };
        _this.findDataIndexByXPos = function (xPos) {
            var _a = _this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, padding = _a.padding;
            var _b = _this.state, yScale = _b.yScale, xScale = _b.xScale, xValues = _b.xValues, data = _b.data, hoveredSeriesIndex = _b.hoveredSeriesIndex;
            // Calculate the estimated xValue based on mouse position
            var xValue = xScale.invert(xPos).getTime() / 1000;
            // Gather all of the available xValues that don't have null yAxisValues from all data arrays
            var xKeysObject = {};
            var xKeyValues = data.reduce(function (combinedArray, currentArray, index) {
                combinedArray = combinedArray.concat(currentArray.reduce(function (returnArray, item, itemIndex) {
                    if (item[yAxisKey] !== null && item[yAxisKey] !== undefined) {
                        returnArray.push(item[xAxisKey]);
                        xKeysObject[item[xAxisKey]] = itemIndex;
                    }
                    return returnArray;
                }, []));
                return combinedArray;
            }, []);
            xKeyValues = Object.keys(xKeysObject)
                .map(function (value) {
                return parseInt(value, 10);
            })
                .sort(function (v1, v2) {
                return v1 - v2;
            });
            // Find the closest xKeyValue from the available xKeyValues
            var xKeyIndex = d3.bisectLeft(xKeyValues, xValue);
            // If the position is further than valid values, set to the furthest right value
            if (xKeyIndex >= xKeyValues.length) {
                xKeyIndex = xKeyValues.length - 1;
            }
            // Get the xKeyValue key from the xKeysObject
            var xKey = Object.keys(xKeysObject)[xKeyIndex];
            var xPreviousKey = Object.keys(xKeysObject)[xKeyIndex ? xKeyIndex - 1 : 0];
            // Get the real index from the xKeysObject using the xKey
            var xPosIndex = xKeysObject[xKey];
            var xPosPreviousIndex = xKeysObject[xPreviousKey];
            if (xPosIndex === 0) {
                return 0;
            }
            // get the nearest values
            var d0 = data[0][xPosPreviousIndex];
            var d1 = data[0][xPosIndex];
            // get the nearest
            var x0 = d0[xAxisKey];
            var x1 = d1[xAxisKey];
            var closestDataIndex = xValue - x0 > x1 - xValue ? xPosIndex : xPosPreviousIndex;
            return closestDataIndex;
        };
        _this.axisElements = function () {
            var xSettings = {
                translate: "translate(0, " + (_this.props.height - _this.props.padding) + ")",
                scale: _this.state.xScale,
                orient: 'bottom',
                tickFormat: d3.format('.0s'),
                size: _this.state.size,
                tickValues: _this.state.xAxisTickValues
            };
            var _a = _this.state, xAxisTickValues = _a.xAxisTickValues, xAxisGranularity = _a.xAxisGranularity;
            if (_this.props.dateSeries) {
                xSettings.tickFormat = function (input, index) {
                    if (xAxisGranularity === 30) {
                        var currXAxisTickYear = xAxisTickValues[index].getFullYear();
                        var prevXAxisTickYear = index > 0
                            ? xAxisTickValues[index - 1].getFullYear()
                            : currXAxisTickYear;
                        // the format should be like 'Jan 2015' when we encounter a new year
                        if (currXAxisTickYear > prevXAxisTickYear) {
                            return Moment.utc(input).format('MMM YYYY');
                        }
                        else {
                            return Moment.utc(input).format('MMM');
                        }
                    }
                    else {
                        return Moment.utc(input).format('MMM D');
                    }
                };
            }
            var ySettings = {
                translate: "translate(" + _this.props.padding + ", 0)",
                scale: _this.state.yScale,
                orient: 'left',
                tickFormat: function (input) {
                    // If the input value is under 1.0, the s will format is as millions....
                    if (input < 1.0) {
                        return d3
                            .format('.2')(input)
                            .replace('.0', '');
                    }
                    return d3
                        .format('.2s')(input)
                        .replace('.0', '');
                },
                size: _this.state.size,
                domain: _this.state.yScale.domain()
            };
            return (React.createElement("g", { className: "axis" },
                React.createElement(Axis_1.default, __assign({}, xSettings, { key: 'x-axis-component' })),
                React.createElement(Axis_1.default, __assign({}, ySettings, { key: 'y-axis-component' }))));
        };
        _this.generateXTicks = function (xTicksCandidates, minTicks, maxTicks) {
            var numOfPoints = xTicksCandidates.length;
            if (numOfPoints <= minTicks) {
                return xTicksCandidates.map(function (tick) {
                    return new Date(tick * 1000);
                });
            }
            var foundBestNumberOfTicks = false;
            var bestNumberOfTicks = minTicks;
            var remainders = [];
            // if the number of data points is divisible by a certain number of ticks, use that
            for (var i = minTicks; i <= maxTicks; i++) {
                var remainder = numOfPoints % i;
                if (remainder === 0) {
                    foundBestNumberOfTicks = true;
                    bestNumberOfTicks = i;
                    break;
                }
                remainders.push(remainder);
            }
            // if none of them applies, use the one with the least remainder
            if (!foundBestNumberOfTicks) {
                var min = remainders[0];
                var minIndex = 0;
                for (var i = 1; i < remainders.length; i++) {
                    if (remainders[i] < min) {
                        minIndex = i;
                        min = remainders[i];
                    }
                }
                bestNumberOfTicks = minIndex + minTicks;
            }
            var interval = Math.ceil(numOfPoints / bestNumberOfTicks);
            var ticks = xTicksCandidates.filter(function (element, index) {
                return index % interval === 0;
            });
            ticks = ticks.map(function (tick) {
                return new Date(tick * 1000);
            });
            return ticks;
        };
        _this.toolTipElements = function () {
            var _a = _this.props, yAxisKey = _a.yAxisKey, xAxisKey = _a.xAxisKey, chartType = _a.chartType, showGlobalTotal = _a.showGlobalTotal;
            var _b = _this.state, hoveredDataIndex = _b.hoveredDataIndex, yScale = _b.yScale, xScale = _b.xScale, data = _b.data, tooltipPosition = _b.tooltipPosition;
            var self = _this;
            var tooltipPositions = [];
            var tooltipElements = React.Children.map(_this.props.children, function (child, index) {
                if (!React.isValidElement(child)) {
                    return null;
                }
                if (!(hoveredDataIndex > -1)) {
                    return null;
                }
                var childEl = child;
                var childProps = child.props;
                var tooltipDataPoint = data[index][hoveredDataIndex];
                var position = {
                    x: 0,
                    y: yScale(tooltipDataPoint[yAxisKey]) - 25,
                    index: index
                };
                // aggregate override
                if (chartType === 1) {
                    position = __assign({}, position, { y: yScale(tooltipDataPoint[cumulativeKey]) - 25 });
                }
                tooltipPositions.push(position);
                return childProps.tooltip || null;
            });
            if (tooltipElements && tooltipElements.length > 0) {
                var sortedTooltipPositions = tooltipPositions.sort(function (v1, v2) {
                    return v1.y - v2.y;
                });
                var estimatedTooltipHeight_1 = _this.state.toolTipHeight || 24;
                var lastYPosition_1 = 0;
                var updatedTooltipPositions = sortedTooltipPositions.map(function (position, index) {
                    // Update the lastYPosition and return if this is the highest tooltip
                    if (index === 0) {
                        lastYPosition_1 = position.y;
                        return position;
                    }
                    // if the current position.y is less than the lastYPosition + estimatedTooltipHeight
                    if (position.y < lastYPosition_1 + estimatedTooltipHeight_1) {
                        // calculate the overlapped distance
                        var overlapDistance = lastYPosition_1 + estimatedTooltipHeight_1 - position.y;
                        // move the current position down by the overlap distance
                        position.y = position.y + overlapDistance;
                        // update the lastYPosition
                        lastYPosition_1 = position.y;
                    }
                    else {
                        lastYPosition_1 = position.y;
                    }
                    return position;
                });
                var globalTotal_1 = 0;
                var WrappedTooltips = updatedTooltipPositions.map(function (position, index) {
                    var _this = this;
                    var displayMode = 'block';
                    if (data[position.index][hoveredDataIndex][yAxisKey] === null ||
                        data[position.index][hoveredDataIndex][yAxisKey] === undefined) {
                        displayMode = 'none';
                    }
                    else {
                        globalTotal_1 += data[position.index][hoveredDataIndex][yAxisKey];
                    }
                    var divStyle = {
                        position: 'absolute',
                        top: position.y + 'px',
                        display: displayMode
                    };
                    if (tooltipPosition.flipped) {
                        divStyle.right = '0px';
                    }
                    else {
                        divStyle.left = '0px';
                    }
                    return (React.createElement("div", { ref: function (element) { return _this.toolTipRef(element); }, style: divStyle, key: position.y }, tooltipElements[position.index]));
                }.bind(_this));
                var TotalTooltip = function (props) {
                    var divStyle = {
                        position: 'absolute',
                        top: '35px'
                    };
                    if (tooltipPosition.flipped) {
                        divStyle.right = '0px';
                    }
                    else {
                        divStyle.left = '0px';
                    }
                    return (React.createElement("div", { ref: function (element) { return _this.toolTipRef(element); }, style: divStyle, key: 'total-tooltip' },
                        React.createElement("div", { style: {
                                padding: '7px 4px 4px 4px',
                                backgroundColor: 'white',
                                display: 'flex',
                                width: 'max-content',
                                boxShadow: 'rgba(0, 0, 0, 0.117647) 0 1px 6px, rgba(0, 0, 0, 0.117647) 0 1px 4px'
                            } },
                            React.createElement("h4", { style: {
                                    flexShrink: 0,
                                    fontSize: '14px'
                                } }, "Global Total"),
                            React.createElement("data", { style: { fontWeight: 600, marginLeft: '12px' } }, globalTotal_1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')))));
                };
                if (showGlobalTotal) {
                    return [WrappedTooltips, React.createElement(TotalTooltip, { key: 'total-tooltip' })];
                }
                else {
                    return WrappedTooltips;
                }
            }
            else {
                return null;
            }
        };
        _this.activeElements = function () {
            var _a = _this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, chartType = _a.chartType;
            var _b = _this.state, xScale = _b.xScale, yScale = _b.yScale, activeSeriesIndex = _b.activeSeriesIndex, activeDataIndex = _b.activeDataIndex, hoveredSeriesIndex = _b.hoveredSeriesIndex, hoveredDataIndex = _b.hoveredDataIndex, size = _b.size, data = _b.data;
            if (hoveredDataIndex > -1 && data) {
                var displayDate_1 = '';
                var circleProps_1 = {};
                var cursorProps_1 = {};
                var focusedDots = data.map(function (dataArray, index) {
                    var focusedDataPoint = dataArray[hoveredDataIndex];
                    var dataSeriesColor = this.props.children[index].props.color || '#ccc';
                    var insideColorStyles = {
                        fill: dataSeriesColor
                    };
                    var outsideColorStyles = {
                        stroke: dataSeriesColor
                    };
                    circleProps_1 = {
                        cx: xScale(focusedDataPoint[xAxisKey]),
                        cy: yScale(focusedDataPoint[yAxisKey]),
                        r: 4
                    };
                    // make sure there's a valid cx position and then use it to position the dotted line (cursor)
                    if (circleProps_1.cx) {
                        cursorProps_1 = circleProps_1;
                    }
                    // aggregate override
                    if (chartType === 1) {
                        circleProps_1 = __assign({}, circleProps_1, { cy: yScale(focusedDataPoint[cumulativeKey]) });
                        // missing data override, currently disabled until deemed necessary
                    }
                    else if (focusedDataPoint[yAxisKey] === undefined ||
                        focusedDataPoint[yAxisKey] === null) {
                        circleProps_1 = {};
                    }
                    displayDate_1 = Moment.utc(focusedDataPoint[xAxisKey] * 1000).format('MMM D');
                    return (React.createElement("g", { key: dataSeriesColor +
                            circleProps_1.cx +
                            circleProps_1.cy +
                            'data-point--active' },
                        React.createElement("circle", __assign({ className: "data-point-active-inside" }, circleProps_1, { style: insideColorStyles, key: circleProps_1.cx + circleProps_1.cy + 'data-point-active-inside' })),
                        React.createElement("circle", __assign({ className: "data-point-active-outside" }, circleProps_1, { style: outsideColorStyles, r: "6", key: circleProps_1.cx + circleProps_1.cy + 'data-point-active-outside' }))));
                }.bind(_this));
                return (React.createElement("g", { className: "focus selected" },
                    React.createElement("g", { className: "cursor" },
                        React.createElement("line", { className: "x-cursor cursor", x1: cursorProps_1.cx, y1: size.height - size.padding, x2: cursorProps_1.cx, y2: size.padding }),
                        React.createElement("text", { className: "x-label label", y: size.padding + 10, x: cursorProps_1.cx + 6, textAnchor: "start" }, displayDate_1)),
                    focusedDots));
            }
            return null;
        };
        _this.circleElements = function () {
            // This method returns all <circle/> elements built from the data prop
            var self = _this;
            var _a = _this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey;
            var _b = _this.state, xScale = _b.xScale, yScale = _b.yScale, hoveredSeriesIndex = _b.hoveredSeriesIndex, data = _b.data;
            var allCircles = data.map(function (array, seriesIndex) {
                var circleElements = array.map(function (item, index) {
                    var insideRadius = 3, outsideRadius = 4;
                    var circleProps = {
                        cx: xScale(item[xAxisKey]),
                        cy: yScale(item[yAxisKey]),
                        r: insideRadius,
                        key: index,
                        'data-index': index,
                        'data-series-index': seriesIndex
                    };
                    return (React.createElement("g", { className: "data-points", key: circleProps.key + 'circlePair' },
                        React.createElement("circle", __assign({}, circleProps, { className: "data-point-inside" })),
                        React.createElement("circle", __assign({}, circleProps, { className: "data-point-outside", r: outsideRadius, key: circleProps.key + 'outside' }))));
                });
                // Using old style classes for now... Apply -gray for 0, otherwise subtract 1 to start at 0...
                var colorSuffix = seriesIndex;
                if (colorSuffix === 0) {
                    colorSuffix = 'gray';
                }
                else {
                    colorSuffix = colorSuffix - 1;
                }
                var dataSeriesClasses = 'data-series color-' + colorSuffix + ' series-' + colorSuffix;
                return (React.createElement("g", { key: dataSeriesClasses, style: {
                        display: seriesIndex === hoveredSeriesIndex ? 'inherit' : 'none'
                    } }, circleElements));
            });
            return React.createElement("g", { className: "points" }, allCircles);
        };
        _this.lineChartParentRefCallback = function (component) {
            if (component) {
                _this.setState({
                    root: component
                });
            }
        };
        _this.state = __assign({ activeSeriesIndex: -1, hoveredSeriesIndex: -1, tooltipPosition: { x: null, y: null, flipped: false } }, _this.generateD3State(props));
        return _this;
    }
    LineChart.prototype.componentWillMount = function () {
        document.addEventListener('click', this.handleDocumentClick, false);
    };
    LineChart.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleDocumentClick);
    };
    LineChart.prototype.componentDidMount = function () {
        this.setState(__assign({}, this.generateD3State(this.props)));
        monitoring_1.default('lineChart');
    };
    LineChart.prototype.componentWillReceiveProps = function (newProps) {
        this.setState(__assign({}, this.generateD3State(newProps)));
    };
    LineChart.prototype.findPreviousRealValueIndex = function (data, index, yAxisKey) {
        var prevRealValueIndex = null, counter = index;
        while (prevRealValueIndex === null) {
            if (counter >= 0) {
                if (data[counter][yAxisKey] !== undefined &&
                    data[counter][yAxisKey] !== null) {
                    prevRealValueIndex = counter;
                    return prevRealValueIndex;
                }
            }
            else {
                return null;
            }
            counter--;
        }
    };
    LineChart.prototype.findNextRealValueIndex = function (data, index, yAxisKey) {
        var nextRealValueIndex = null, counter = index;
        while (nextRealValueIndex === null) {
            if (counter < data.length) {
                if (data[counter][yAxisKey] !== undefined &&
                    data[counter][yAxisKey] !== null) {
                    nextRealValueIndex = counter;
                    return nextRealValueIndex;
                }
            }
            else {
                return null;
            }
            counter++;
        }
    };
    LineChart.prototype.estimateIncrementBetweenIndexes = function (data, startingIndex, endingIndex, yAxisKey) {
        var numberOfDataPoints = endingIndex - startingIndex;
        // Get the difference in the start and end values
        var differenceInDataValues = data[endingIndex][yAxisKey] - data[startingIndex][yAxisKey];
        // Calculate the increment per dashed line.
        var incrementPerDataPoint = differenceInDataValues / numberOfDataPoints;
        return incrementPerDataPoint;
    };
    LineChart.prototype.render = function () {
        var self = this, props = this.props;
        var data = props.data;
        var _a = this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, showAreas = _a.showAreas, className = _a.className, style = _a.style;
        var _b = this.state, yScale = _b.yScale, xScale = _b.xScale, size = _b.size, tooltipPosition = _b.tooltipPosition;
        var classes = classNames('line-chart', className);
        var dataSeriesElements = this.state.dataSeriesElements;
        var tooltipContainerPosition = tooltipPosition.x;
        if (!tooltipPosition.flipped) {
            tooltipContainerPosition += 28;
        }
        return (React.createElement("div", { className: classes, ref: this.lineChartParentRefCallback, style: style },
            React.createElement(Chart_1.default, { width: this.props.width, height: this.props.height, padding: this.props.padding, onMouseOut: this.onChartMouseOut, onMouseMove: this.onChartMouseOver, onClick: this.onChartClick },
                dataSeriesElements,
                this.axisElements(),
                this.activeElements()),
            React.createElement("div", { style: {
                    position: 'absolute',
                    left: tooltipContainerPosition,
                    top: 0,
                    height: '100%',
                    pointerEvents: 'none'
                } }, this.toolTipElements())));
    };
    LineChart.defaultProps = {
        title: '',
        interpolate: 'linear',
        yAxisKey: 'y',
        xAxisKey: 'x',
        padding: 30,
        data: [],
        dateSeries: true
    };
    return LineChart;
}(React.Component));
exports.default = LineChart;
//# sourceMappingURL=LineChart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/LineChart/LineChart.js
// module id = 365
// module chunks = 0